import React from "react";
import { Image as ChakraImage, forwardRef, ImageProps } from "@chakra-ui/react";
import { Box } from "Shared";

export const Image = forwardRef((props: ImageProps, ref) => {
  return <ChakraImage ref={ref} fallback={<Box bg="gray.50" />} {...props} />;
});
